import classNames from 'classnames';
import style from './style.module.scss';
import { useSelector } from 'react-redux';

const CustomButton = ({ text, submitHandle, containerStyle, IconStyle, Icon, btnRole, Id, invalid, style: customInlineStyle }) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    return (
        <>
        {invalid  ? "": 
        <button 
            id={Id} 
            style={{ width: 'max-content', minWidth: 'max-content', whiteSpace: 'nowrap', ...customInlineStyle }}
            className={classNames(style.customButtonContainer, `${theme}SvgIcon`, containerStyle ? containerStyle : '')} 
            onClick={submitHandle} 
            type={btnRole ? btnRole : 'submit'}
        >
            {Icon && <Icon className={classNames(IconStyle, `${theme}SvgIcon`)} />}
            {text}
        </button>
        }
        
        </>
    );
};

export default CustomButton;
